"use strict";
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.useGetNodeRelations = void 0;
const react_1 = require("react");
const react_2 = require("@apollo/client/react");
const get_node_relations_query_1 = require("../gql/get-node-relations.query");
const client_utils_1 = require("../../../client/client.utils");
const useGetNodeRelations = (_a) => {
    var { sort, productTreeNodeId } = _a, options = __rest(_a, ["sort", "productTreeNodeId"]);
    const { data, error, networkStatus, } = (0, react_2.useQuery)(get_node_relations_query_1.GET_NODE_RELATIONS, Object.assign({ variables: {
            productTreeNodeId,
            sort,
        }, skip: !productTreeNodeId }, options));
    const ancestors = (0, react_1.useMemo)(() => { var _a; return (_a = data === null || data === void 0 ? void 0 : data.productTreeNode.ancestors.edges) !== null && _a !== void 0 ? _a : []; }, [data]);
    const isTerminal = (0, react_1.useMemo)(() => (data === null || data === void 0 ? void 0 : data.productTreeNode.descendants.totalCount) === 1, [data]);
    const currentNode = (0, react_1.useMemo)(() => {
        var _a;
        const { id, title } = (_a = data === null || data === void 0 ? void 0 : data.productTreeNode) !== null && _a !== void 0 ? _a : {};
        return { id, title };
    }, [data]);
    return {
        currentNode,
        data: ancestors,
        isTerminal,
        isLoading: (0, client_utils_1.isQueryLoadingOrRefetching)(networkStatus),
        error: error === null || error === void 0 ? void 0 : error.message,
    };
};
exports.useGetNodeRelations = useGetNodeRelations;
